import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFlag  } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch, SubmitButton } from '../architecture/frontend/index'
import _ from 'lodash'
import { filter } from 'rxjs/operators'
import loading from '../../media/loading.svg'
import EntryItem from '../EntryTypes'

const ClaimDetails = (props) => {
  const disabled = _.isNil(props.shipment?.id)
  const disabledStyle = disabled ? {pointerEvents: 'none'} : {}
  const disabledClass = disabled ? ' o-50 ' : ''
return (
  <>
    <div className='pt2'>
      <div className='w-100 pa2 ph3 flex items-center bg-evonik-purple justify-between' >
        <div className='pv2 flex'>
          <FontAwesomeIcon className='f6 white ' icon={faFlag}/>
          <div className='pl2 fw7 f6 white'>Claim</div>
        </div>
        <div className='flex'>
          {props.shipment.claimDeniedDate ?
            <SubmitButton id={'save'} className='' 
              responseId='save'
              defaultChild={ props => (
                <div className='ml2 pa2 ph3 bg-evonik-light-purple br2 white f6 pointer' onClick={e => Dispatch.nextAction('claim.reopen')}>
                  Reopen Claim
                </div>
              )}
              loadingChild={ props => (
                  <div className='mh3 ' style={{width:28}}>
                    <img src={loading} alt='loading' />
                  </div>
              )}
              errorChild={ props => (
                <div className='pl3 f7 fw4 red tr pointer'>Error</div>
              )}
              loadingStream={
                Dispatch.getAction('Request.reopen')
                }
              successStream={
                Dispatch.getAction('Response.reopen')
                  .pipe(
                    filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.reopenClaim) || !_.isNil(e.data.reopenClaim) ))),
                  )
                }
              errorStream={
                Dispatch.getAction('Response.reopen')
                  .pipe(
                    filter(e => !_.isNil(e.errors)),
                  )}
            />
            :
              props.shipment.claimPendingDenial ?
                <SubmitButton id={'save'} className='' 
                responseId='save'
                defaultChild={ props => (
                  <div className={'ml2 pa2 ph3 bg-evonik-light-purple br2 white f6 pointer ' + disabledClass} 
                    onClick={e => Dispatch.nextAction('claim.removePendingDenial', { id: props.shipment?.id })}
                    style={{...disabledStyle}}>
                    Remove Pending Denial
                  </div>
                )}
                loadingChild={ props => (
                    <div className='mh3 ' style={{width:28}}>
                      <img src={loading} alt='loading' />
                    </div>
                )}
                errorChild={ props => (
                  <div className='pl3 f7 fw4 red tr pointer'>Error</div>
                )}
                loadingStream={
                  Dispatch.getAction('Request.removePendingDenial')
                  }
                successStream={
                  Dispatch.getAction('Response.removePendingDenial')
                    .pipe(
                      filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.upsertShipment) || !_.isNil(e.data.upsertShipment) ))),
                    )
                  }
                errorStream={
                  Dispatch.getAction('Response.removePendingDenial')
                    .pipe(
                      filter(e => !_.isNil(e.errors)),
                  )}
              />
              :
                <SubmitButton id={'save'} className='' 
                  responseId='save'
                  defaultChild={ props => (
                    <div className={'ml2 pa2 ph3 bg-evonik-light-purple br2 white f6 pointer ' + disabledClass} 
                      onClick={e => Dispatch.nextAction('claim.deny', { id: props.shipment?.id, toAddress: null, message: null })}
                      style={{...disabledStyle}}>
                      Deny Claim
                    </div>
                  )}
                  loadingChild={ props => (
                      <div className='mh3 ' style={{width:28}}>
                        <img src={loading} alt='loading' />
                      </div>
                  )}
                  errorChild={ props => (
                    <div className='pl3 f7 fw4 red tr pointer'>Error</div>
                  )}
                  loadingStream={
                    Dispatch.getAction('Request.denyClaim')
                    }
                  successStream={
                    Dispatch.getAction('Response.denyClaim')
                      .pipe(
                        filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.denyClaim) || !_.isNil(e.data.denyClaim) ))),
                      )
                    }
                  errorStream={
                    Dispatch.getAction('Response.denyClaim')
                      .pipe(
                        filter(e => !_.isNil(e.errors)),
                      )}
                  />
            // <SubmitButton id={'save'} className='' 
            //   responseId='save'
            //   defaultChild={ props => (
            //     <div className={'ml2 pa2 ph3 bg-evonik-light-purple br2 white f6 pointer ' + disabledClass} 
            //       onClick={e => Dispatch.nextAction('__.Modal.open', {
            //         type: 'email', 
            //         details: {
            //           title: "Send Claim Denied Notice",
            //           description: "Use the following form to send a claim denied notice",
            //           onClick: (e) => Dispatch.nextAction('claim.deny'),
            //           request: 'denyClaim',
            //           dataType: 'denyClaim',
            //         }
            //       })}
            //       style={{...disabledStyle}}>
            //       Deny Claim
            //     </div>
            //   )}
            //   loadingChild={ props => (
            //       <div className='mh3 ' style={{width:28}}>
            //         <img src={loading} />
            //       </div>
            //   )}
            //   errorChild={ props => (
            //     <div className='pl3 f7 fw4 red tr pointer'>Error</div>
            //   )}
            //   loadingStream={
            //     Dispatch.getAction('Request.denyClaim')
            //     }
            //   successStream={
            //     Dispatch.getAction('Response.denyClaim')
            //       .pipe(
            //         filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.denyClaim) || !_.isNil(e.data.denyClaim) ))),
            //       )
            //     }
            //   errorStream={
            //     Dispatch.getAction('Response.denyClaim')
            //       .pipe(
            //         filter(e => !_.isNil(e.errors)),
            //       )}
            // />
          }
          {/* { (!props.shipment.refereeDate && !props.shipment.claimDeniedDate) &&
            <>
              <SubmitButton id={'save'} className='' 
                responseId='save'
                defaultChild={ props => (
                  <div className={'ml2 pa2 ph3 bg-evonik-light-green br2 white f6 pointer ' + disabledClass} style={{...disabledStyle}}
                    onClick={e => Dispatch.nextAction('shipment.toReferee', true)}>
                    Mark for Referee
                  </div>
                )}
                loadingChild={ props => (
                    <div className='mh3 ' style={{width:80, height: 30}}>
                      <img className='w-100 h-100' src={loading} />
                    </div>
                )}
                errorChild={ props => (
                  <div className='pl3 f7 fw4 red tr pointer'>Error</div>
                )}
                loadingStream={
                  Dispatch.getAction('Request.toReferee')
                 .pipe(
                      filter(e => e.variables?.refereeToSend)
                    )
                  }
                successStream={
                  Dispatch.getAction('Response.toReferee')
                    .pipe(
                      filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.upsertShipment) || !_.isNil(e.data.upsertShipment) ))),
                    )
                  }
                errorStream={
                  Dispatch.getAction('Response.toReferee')
                    .pipe(
                      filter(e => !_.isNil(e.errors)),
                    )}
              />
              <SubmitButton id={'save'} className='' 
                responseId='save'
                defaultChild={ props => (
                  <div className={'ml2 pa2 ph3 bg-evonik-light-green br2 white f6 pointer ' + disabledClass} style={{...disabledStyle}}
                    onClick={e => Dispatch.nextAction('shipment.toReferee', false)}>
                    Skip Referee
                  </div>
                )}
                loadingChild={ props => (
                    <div className='mh3 ' style={{width:80, height: 30}}>
                      <img className='w-100 h-100' src={loading} />
                    </div>
                )}
                errorChild={ props => (
                  <div className='pl3 f7 fw4 red tr pointer'>Error</div>
                )}
                loadingStream={
                  Dispatch.getAction('Request.toReferee')
                    .pipe(
                      filter(e => !e.variables?.refereeToSend)
                    )
                  }
                successStream={
                  Dispatch.getAction('Response.toReferee')
                    .pipe(
                      filter(e => _.isNil(e.errors) && ((!_.isNil(e.data.upsertShipment) || !_.isNil(e.data.upsertShipment) ))),
                    )
                  }
                errorStream={
                  Dispatch.getAction('Response.toReferee')
                    .pipe(
                      filter(e => !_.isNil(e.errors)),
                    )}
              />
            </>
          } */}

        </div>
        {/* <div className='pl2 yellow fw6 f4 f3' style={{fontFamily: 'monospace'}}> @42322</div> */}
      </div>
      </div>
      <div className='pv3 ph4 w-100 flex' style={{background: '#f5f3f5'}}>
      <div className='' style={{flexGrow: 2}}>
        <EntryItem _title='Claim Id' _type={'text'} _updateType={'claimId'} _large={true} {...props}/>  
        <EntryItem _title='Referee Lab' _type={'select'}  _updateType={'lab'} _value={_.filter(props.locations?.rawData, location => location.type==='LAB')?.map(type => ({value: type.id, label: type.code + ' - ' + type.name})) ?? [] } {...props}/>
        <EntryItem _title='Referee Attachment' _value={props.shipment?.refereeFile} _type={'file'} {...props}/>
        {/* <EntryItem _title='Claim Date' _child={entryTypes.date}/> */}
        {/* <EntryItem _title='Remarks' _type={'supplier'} {...props}/> */}
      </div>
      <div className='' style={{flexGrow: 1}}>
      <EntryItem _title='' _type={'refereedDate'} {...props}/>
      <EntryItem _title='' _type={'claimDeniedDate'} {...props}/>
      <EntryItem _title='Claim Date' _type={'date'} _updateType={'claimedDate'} {...props}/>
      <EntryItem _title='Referee Fee' _type={'text'} _updateType={'refereeFee'} _large={false} {...props}/>
      <EntryItem _title='Settlement Adjustment' _type={'text'} _updateType={'settlementAdjustmentDollars'} _large={false} {...props}/>
        {/* <EntryItem _title='Invoice Amount' _child={entryTypes.date}/>
        <EntryItem _title='Tons' _child={entryTypes.date}/> */}
      {/* <div className='flex items-center'>
        <div className='w4'></div>
          <div className='ml4 mt4 pa2 w4 bg-evonik-light-purple br2 white f6 tc'>
            Deny Claim
        </div>
      </div> */}
      </div>
    </div>
  </>
  )
}

export default ClaimDetails